import React, { useState, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu } from './Components/Menu';
import { SettingsMenu } from './Components/SettingsMenu';
import { Forklift, AlignJustify } from 'lucide-react';

const DashboardLayout = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSettingsMenuOpen, setIsSettingsMenuOpen] = useState(false);

  const buttonRef = useRef(null);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleSettingsMenu = () => setIsSettingsMenuOpen(!isSettingsMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);
  const closeSettingsMenu = () => setIsSettingsMenuOpen(false);
  const openSettingsMenu = () => setIsSettingsMenuOpen(true);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="fixed top-0 w-full flex items-center justify-between z-20 bg-white shadow-sm">
        <button
          ref={buttonRef}
          onClick={!isSettingsMenuOpen ? openSettingsMenu : closeSettingsMenu}
          className="text-orange-500 p-3"
          aria-label="Toggle Settings Menu"
        >
          <AlignJustify className="w-6 h-6" />
        </button>
        <a href={"/"}>
            <img
              src="/logo-bold.png"
              alt="Nijhuis Tracking"
              className="h-12 w-auto object-contain"
            />
        </a>
        <button
          onClick={toggleMenu}
          className="text-orange-500 p-3"
          aria-label="Toggle Machine Menu"
        >
          <Forklift className="w-6 h-6" />
        </button>
      </header>

      {/* Main Content */}
      <main className="grow pt-14 bg-gray-100">
        <Outlet />
      </main>

      {/* Menus */}
      <Menu isMenuOpen={isMenuOpen} closeMenu={closeMenu} />
      <SettingsMenu isSettingsMenuOpen={isSettingsMenuOpen} closeSettingsMenu={closeSettingsMenu} buttonRef={buttonRef} />
    </div>
  );
};

export default DashboardLayout;